export const QUERY_KEYS = {
  getQBCancelRequestList: () => ['getQuestionBankCancelRequestList'] as const,
  getTutoringCancelRequestList: () => ['getTutoringCancelRequestList'] as const,
};
